import "./FilterByStatus.css";

import { EXPERIMENT_STATUS, MAP_MODES, PLOTMAP_STATUS } from "../../constants";
import { selectFilteredTrials, selectSortedTrials } from "../../selectors/user";
import { useDispatch, useSelector } from "react-redux";

import { Input } from "reactstrap";
import { setFilterByStatusMode } from "../../actions/resultMap";
import { useMemo } from "react";

export const FilterByStatus = () => {
  const [mapMode, selectedTrial, filterByStatusMode] = useSelector(
    ({ resultMap }) => [
      resultMap.mapMode,
      resultMap.trial,
      resultMap.filterByStatusMode,
    ]
  );

  const trials = useSelector(
    selectedTrial && mapMode === MAP_MODES.MARKERS
      ? selectSortedTrials
      : selectFilteredTrials
  );

  let totalTrialsWithActionsRequired = useMemo(() => {
    return trials.reduce((count, trial) => {
      const matchesStatus =
        [EXPERIMENT_STATUS.NOT_STARTED, EXPERIMENT_STATUS.DRAFT].includes(
          trial.experiment_status
        ) || trial.plotmap_status === PLOTMAP_STATUS.WAITING_FOR_VALIDATION;

      return count + (matchesStatus ? 1 : 0);
    }, 0);
  }, [trials]);

  const dispatch = useDispatch();

  return (
    <div
      className={`status-filter-panel ${
        totalTrialsWithActionsRequired > 0 ? "attention" : ""
      }`}
    >
      {totalTrialsWithActionsRequired > 0 ? (
        <div className="status-filter">
          {/* The count leads: it is the information. The checkbox below is only
              the action offered on it. */}
          <div className="status-filter-label">
            <i className="fa-solid fa-triangle-exclamation " />
            <span>
              {totalTrialsWithActionsRequired}{" "}
              {totalTrialsWithActionsRequired === 1
                ? "site requires"
                : "sites require"}{" "}
              your attention
            </span>
          </div>
          <div className="d-flex gap-1 align-items-center ">
            <Input
              id="filterCheckbox"
              type="checkbox"
              checked={filterByStatusMode}
              onChange={(e) => {
                dispatch(setFilterByStatusMode());
              }}
            />
            <div
              className="status-filter-text clickable"
              onClick={() => {
                dispatch(setFilterByStatusMode());
              }}
            >
              <span>Filter sites by</span>
              <div className="status-filter-legend">Client action required</div>
            </div>
          </div>
        </div>
      ) : (
        <div className="status-filter-fallback">
          <i className="fa-solid fa-check" />0 sites currently require your
          attention
        </div>
      )}
    </div>
  );
};
